var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#0D9C7A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 9,
    height: 9,
    rx: 1,
    fill: "#BDFCED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 9,
    height: 9,
    rx: 1,
    fill: "#BDFCED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 9,
    height: 9,
    rx: 1,
    fill: "#BDFCED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3293,
    y: 13,
    width: 9,
    height: 9,
    rx: 1,
    transform: "rotate(15 28.3293 13)",
    fill: "#1C2C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesIcon);
export default __webpack_public_path__ + "static/media/ModulesIcon.0ce3921c094c20c0c24f01f8fbd5db81.svg";
export { ForwardRef as ReactComponent };